import React from 'react';
import { motion } from 'framer-motion';
import { FaWalking, FaWheelchair, FaBolt } from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      icon: <FaWalking size={40} />,
      title: "Ambulatory Transport",
      description: "For patients who can walk independently or with minimal assistance. Our professional drivers provide door-to-door service with a helping hand when needed."
    },
    {
      icon: <FaWheelchair size={40} />,
      title: "Wheelchair Transport",
      description: "Safe and secure transportation for passengers requiring wheelchair accessibility. Our ADA-compliant vehicles are equipped with proper wheelchair securement systems."
    },
    {
      icon: <FaBolt size={40} />,
      title: "Electric Wheelchair Transport",
      description: "Specialized transportation for electric wheelchairs and power mobility devices. Our trained drivers ensure proper handling and securement of electric wheelchairs."
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Our Services
        </motion.h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              className="service-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03, boxShadow: "0 10px 20px rgba(0,0,0,0.1)" }}
            >
              <motion.div 
                className="service-icon"
                whileHover={{ scale: 1.1, rotate: 5 }}
              >
                {service.icon}
              </motion.div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 